"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.monthNames = exports.dateToISO = exports.countDaysDiffBtnDates = exports.findNumberOfDaysInMonth = exports.addMs = exports.addDays = exports.addMonths = exports.yearsList = exports.addYears = exports.parseDate = exports.formatTime = exports.formatDateFromObject = exports.formatDate = exports.format = void 0;

var string_1 = require("./string");

exports.format = {
  date: 'd-m-Y',
  dateTime: 'd-m-Y H:i'
};

exports.formatDate = function (timestamp) {
  if (typeof timestamp === 'undefined') {
    return '';
  }

  var date = new Date(timestamp);
  var day = date.getDate();
  var monthIndex = date.getMonth();
  var year = date.getFullYear();
  var month = monthIndex + 1;
  return string_1.padding(day, 2) + '.' + string_1.padding(month, 2) + '.' + string_1.padding(year, 4);
};

exports.formatDateFromObject = function (obj) {
  if (typeof obj !== 'object') {
    return '';
  }

  var day = obj.getDate();
  var month = obj.getMonth() + 1;
  var year = obj.getFullYear();
  return string_1.padding(year, 4) + '-' + string_1.padding(month, 2) + '-' + string_1.padding(day, 2);
};

exports.formatTime = function (timestamp) {
  var date = new Date(timestamp);
  var seconds = date.getSeconds();
  var minutes = date.getMinutes();
  var hours = date.getHours();
  return string_1.padding(hours, 2) + ':' + string_1.padding(minutes, 2) + ':' + string_1.padding(seconds, 2);
};

exports.parseDate = function (date) {
  return {
    day: date.getDate(),
    month: date.getMonth() + 1,
    year: date.getFullYear()
  };
};

exports.addYears = function (date) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return new Date(date.setFullYear(date.getFullYear() + n));
};

exports.yearsList = function () {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  var year = date.getFullYear();
  var r = [];
  var i = 0;

  while (i < n) {
    var y = year - n + i + 1;
    r.push(y);
    i += 1;
  }

  return r;
};

exports.addMonths = function (date) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return new Date(date.setMonth(date.getMonth() + n));
};

exports.addDays = function (date) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return new Date(date.setDate(date.getDate() + n));
};

exports.addMs = function (date) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return new Date(date.setMilliseconds(n));
};

exports.findNumberOfDaysInMonth = function (month) {
  var year = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date().getFullYear();
  var nMonth = month;
  var nYear = year;

  if (month === 12) {
    nMonth = 1;
    nYear = year + 1;
  }

  var datePlusOneDay = new Date(nYear, nMonth - 1, 1);
  return exports.addDays(datePlusOneDay, -1).getDate();
};

exports.countDaysDiffBtnDates = function (d1, d2) {
  var oneDay = 24 * 60 * 60 * 1000;
  return Math.ceil(Math.abs((d1.getTime() - d2.getTime()) / oneDay));
};

exports.dateToISO = function (d) {
  if (d instanceof Date && typeof d.toISOString === 'function') {
    return d.toISOString();
  }

  if (typeof d === 'string') {
    var s = d.toString();
    return new Date(s).toISOString();
  }

  return undefined;
};

exports.monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Seq', 'Oct', 'Nov', 'Dec'];